var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftToBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8531 8.35312L11.2063 8L10.8531 7.64687L6.85312 3.64687L6.5 3.29375L5.79375 4L6.14688 4.35313L9.29375 7.5H0.5H0V8.5H0.5H9.29375L6.14688 11.6469L5.79375 12L6.5 12.7063L6.85312 12.3531L10.8531 8.35312ZM10.5 14H10V15H10.5H15.5H16V14.5V1.5V1H15.5H10.5H10V2H10.5H15V14H10.5Z",
    fill: "#1D1F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftToBracket);
export default __webpack_public_path__ + "static/media/arrow-left-to-bracket.d78f5a53a93543dc12ed058b5747c3e4.svg";
export { ForwardRef as ReactComponent };